import { HSN_URL, QUALITYPARAMETER_URL } from '../../CONSTANTS'
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from 'axios'
import Cookies from 'universal-cookie';

const cook = new Cookies().get('loginData1')


const headersdata = {
    'content-type': 'application/json',
    'Accept': 'application/json',
    'Authorization': cook != undefined ? cook.accessToken : ''
    // 'Authorization': url.Auth_Token
}

export const updateQualityParaMeter = (id,data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .put(QUALITYPARAMETER_URL()+id, data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const addQualityParaMeter = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(QUALITYPARAMETER_URL(), data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getQualityParaMeterKeyValuePair = (id) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(QUALITYPARAMETER_URL() + "getKeyValueList", { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemDetail axios!");
                });
        } catch (error) {
            console.error("in LoginService > getItemDetail, Err===", error);
            reject(SYSTEM_ERROR);
        }
    });
};

export const getQualityParameterList = (search) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(QUALITYPARAMETER_URL() + "getAllRecords", {
                    "page": 0,
                    "search": search,
                    "size": -1
                }, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemDetail axios!");
                });
        } catch (error) {
            console.error("in LoginService > getItemDetail, Err===", error);
            reject(SYSTEM_ERROR);
        }
    });
};
